import moment from 'moment'

export const shouldShowExpiryCountdown = ({ publishEndAt }) => {
  const currentTime = moment()

  const remainingDays = moment(publishEndAt).diff(currentTime, 'days', true)

  return remainingDays <= 10
}
